<template>
<svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="m20.03 1.719 2.25 2.25.22.531v17.25l-.75.75H2.25l-.75-.75V2.25l.75-.75H19.5l.53.219ZM3 3v18h18V4.812L19.19 3H16.5v6H6V3H3Zm9 0v4.5h3V3h-3Z" clip-rule="evenodd"></path>
</svg>
</template>
